<template>
  <div>
    <router-view v-slot="{ Component }">
      <keep-alive :include="includeInKeepAlive">
        <component :is="Component" />
      </keep-alive>
    </router-view>
</div>
</template>
<script>
import { useRouterViewMeta } from '@/composables/useRouterViewMeta'

export default {
  name: 'RouterPassThrough',
  setup () {
    const routerViewMeta = useRouterViewMeta()
    return {
      ...routerViewMeta
    }
  },
  inheritAttrs: false,
  components: {}
}
</script>
